import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../config/apiConfig";

const HelpArticle = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/api/help-articles/${encodeURIComponent(slug)}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setArticle(data);
      } catch (error) {
        console.error("Failed to load help article:", error);
        setArticle(null);
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchArticle();
  }, [slug]);

  const heading = article?.heading || article?.Heading;
  const bodyHtml = article?.bodyHtml || article?.BodyHtml;

  return (
    <>
      <Header />

      <main className="rbt-main-wrapper">
        <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapTop rbt-section-gapBottom">
          <div className="rbt-article-content-wrapper">
            <div className="content">
              <div className="mb-3">
                <Link to="/help" style={{ textDecoration: "none" }}>
                  ← Back to Help Center
                </Link>
              </div>

              <h4 style={{ fontSize: "48px" }}>
                {heading || (loading ? "Loading..." : "Help Article")}
              </h4>

              <div className="rich-html-wrapper">
                <div
                  className="rich-html-inner"
                  dangerouslySetInnerHTML={{
                    __html: loading
                      ? "<p>Loading...</p>"
                      : bodyHtml || "<p>Article not found.</p>",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </main>

      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default HelpArticle;
